import axios from 'axios';

import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
// import { store } from '../../configureStore';

// export const GET_NBS_API = 'GET_NBS_API';
// export const getOrderNBSData = (data) => ({
//   type: 'GET_ORDER_NBS_API',
//   data,
// });

// export const getOrderNbsAPI = () => {
//   const postData = {
//     getCartDetails: true,
//   };
//   store.dispatch({ type: 'NBS_CALLED_ORDER', response: true });
//   return HttpService.post(`${getSecureBaseUrl()}${apiUrls().estimatedBillSummary}`, postData);
// };

export const getAgreementDetails = (data) => ({
  type: Constants.GET_AGREEMENT_DETAILS,
  data,
});

// retrieveCart
export const retrieveCart = (data) => ({
  type: Constants.GET_CART_DETAILS,
  data,
});

export const openTosMobile = (data) => ({
  type: Constants.OPEN_TOS_MOBILE,
  data,
});

export const completeOrderButtonClicked = (data) => ({
  type: Constants.ORDER_COMPLETE_BUTTON_CHANGE,
  response: data,
});

export const getData = () => {
  const postData = {
    installmentContracts: true,
    customerAgreements: true,
  };
  // setCookie('XSRF-TOKEN', "5163ff28-f150-44e5-9d38-405b3b0d86ed");
  // termsAndConditionsurl: '/orderprocessservice/checkoutapi/5g/getAgreementDetails',
  const apiURL = `${getSecureBaseUrl()}${apiUrls().termsAndConditionsurl}`;
  // return HttpService.post(apiURL, postData, { headers });
  return HttpService.post(apiURL, postData);
};

export const orderUpdateShippingAddress = (data, homePhoneAdded) => ({
  type: Constants.ORDERUPDATE_SHIPPING_ADDRESS,
  data,
  homePhoneAdded,
});

// for fetchingMtns
export const orderFetchSMSEnabledDevices = (data) => ({
  type: Constants.ORDER_GET_ENABLED_DEVICES,
  data,
});

export const orderSecurePinSendSMS = (data) => ({
  type: Constants.ORDER_GET_SEND_SMS,
  data,
});

export const orderSecurePinValidateAuthCode = (MTN, otp) => ({
  type: Constants.ORDER_CODE_VALIDATION,
  MTN,
  otp,
});

export const orderGetZipDetailsFromApi = (data) => ({
  type: Constants.ORDER_GET_ZIP_DETAILS_FROM_API,
  data,
});

export const enableButton = (data) => ({
  type: 'ENABLE_BUTTON',
  data,
});

export const getSubmitOrderAPItriggered = (data) => ({
  type: 'GET_SUBMIT_ORDER_API_TRIGGERED',
  data,
});

export const getPromos = () => ({
  type: 'GET_PROMOS',
});

export const updateTOSCheckBoxState = (data) => ({
  type: 'UPDATE_TOS_CHECKBOX_STATE',
  response: data,
});

export const getPromosFromAEM = () => {
  const apiUrl = apiUrls().getAddonsPromos;
  // let promoData;
  // axios.get(urlData).then((response) => {
  //   promoData = response.data.promo
  // });
  // return promoData;
  // const postData = { "promoType": "AddOnPromo" }
  // only local purpose
  // apiUrl = `${getSecureBaseUrl()}` + apiUrl;
  return axios.get(apiUrl);
};
